<script>
import detail from "./components/detail.vue";
import XEUtils from "xe-utils";

export default {
  name: "Paying",
  components: { detail },
  data() {
    return {
      data: [],
      loading: false
    }
  },
  mounted() {
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      this.$axios.get('/account/tenant/paying/all').then((res) => {
        this.$set(this, 'loading', false)
        this.$set(this, 'data', res.data.data)
        this.data.forEach((item) => {
          item.tenantId = item.id
          const time = XEUtils.timestamp(new Date())
          const deadlineTime = XEUtils.timestamp(item.deadline)
          if (deadlineTime > time) {
            if (deadlineTime - time > 1296000000) {
              item.isTrue = 0
            } else {
              item.isTrue = 1
            }
          } else if (deadlineTime <= time) {
            item.isTrue = 2
          }
        })
      }).catch(() => {
        this.$set(this, 'loading', false)
      })
    },
    setCreate() {
      const e = {
        data: {
          payingAccountName: '北京互链时空数字科技有限公司',
          payingAccountNum: '110938732910305',
          payingAccountBank: '招商银行股份有限公司北京太阳宫支行'
        },
        name: '创建付费企业'
      }
      this.$refs.detail.display(e)
    },
    setUpdate(row) {
      const e = {
        data: row,
        name: '修改付费企业'
      }
      this.$refs.detail.display(e)
    },
    setDelete(row) {
      this.$axios.post('/account/tenant/paying/remove', row).then(() => {
        this.$message.success({ showClose: true, message: '删除成功！' })
        this.init()
      })
    }
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px">
      <div class="fl">
        <span style="font-size: 22px; margin-right: 10px;">付费企业管理</span>
        <el-button type="primary" @click="setCreate()" size="mini">创建</el-button>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="80%" v-loading="loading"
      highlight-current-row>
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column prop="name" label="企业名称" min-width="180" show-overflow-tooltip align="center" />
      <el-table-column prop="deadline" label="到期时间" width="160" show-overflow-tooltip align="center">
        <template v-slot="scope">
          <span v-if="scope.row.isTrue === 2" style="color: #F56C6C">{{ scope.row.deadline }}</span>
          <span v-if="scope.row.isTrue === 1" style="color: #E6A23C">{{ scope.row.deadline }}</span>
          <span v-if="scope.row.isTrue === 0">{{ scope.row.deadline }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="到期类型" width="100" show-overflow-tooltip align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.isTrue === 2 ? 'danger' : scope.row.isTrue === 1 ? 'warning' : 'success'"
            size="mini">
            {{ scope.row.isTrue === 2 ? '已过期' : scope.row.isTrue === 1 ? '即将过期' : '未过期' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="payingInterval" label="缴费周期" width="80" show-overflow-tooltip align="center" />
      <el-table-column prop="payingAmount" label="缴费金额" width="100" show-overflow-tooltip align="center">
        <template v-slot="scope">
          {{ scope.row.payingAmount }} 元
        </template>
      </el-table-column>
      <el-table-column prop="payingAccountName" label="账户名称" width="200" show-overflow-tooltip align="center" />
      <el-table-column prop="payingAccountNum" label="账户号码" width="140" show-overflow-tooltip align="center" />
      <el-table-column prop="payingAccountBank" label="开户银行" min-width="180" show-overflow-tooltip align="center" />
      <el-table-column fixed="right" width="100" label="操作" align="center">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="setUpdate(scope.row)">修改</el-button>
          <el-popconfirm title="确定删除该条单据吗？" style="margin-left: 10px" @confirm="setDelete(scope.row)">
            <template #reference>
              <el-button size="mini" type="text">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <detail ref="detail" @init="init()" />
  </div>
</template>

<style scoped></style>
